import { toProductPage } from './toProductPage';
export var createNavigateExports = function (_a) {
    var context = _a.context, origin = _a.origin;
    return {
        toProductPage: toProductPage({ context: context, origin: origin }),
    };
};
//# sourceMappingURL=exports.navigate.js.map